"use client";
import type { CSSProperties } from "react";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import Button from "@/components/common/Button";
import ProjectCard from "@/components/projects/ProjectCard";
import PROJECTS from "@/data/projects.json";
import Project from "@/types/project";
import ScrollRevealMount from "@/components/common/ScrollRevealMount";
import { useRouter } from "next/navigation";

export default function ProjectSection() {
    const projects = [...PROJECTS as Project[]];
    const latestProjects = projects.slice(0, 3);
    const router = useRouter();

    return (
        <section className="space-y-8">
            <div
                id="sr-home-proj-header"
                className="scroll-reveal-prehide"
                style={{ "--sr-y": "20px" } as CSSProperties}
            >
                <div className="md:flex md:items-center md:justify-between space-y-4 md:space-y-0">
                    <div className="space-y-2">
                        <h2 className="text-4xl font-headline font-bold tracking-tight uppercase">
                            Projets web &amp; applications
                        </h2>
                    </div>
                    <Link href="/projets">
                        <Button size="sm" variant="outline" className="rounded-full! cursor-pointer">
                            <span className="min-w-16">Voir tous <span className="hidden md:inline">mes projets</span></span>
                            <ArrowRight className="size-5 shrink-0" aria-hidden />
                        </Button>
                    </Link>
                </div>
            </div>
            <ScrollRevealMount targetId="sr-home-proj-header" mode="fade" duration={0.55} start="top 88%" />

            <div
                id="sr-home-proj-cards"
                data-gsap-stagger="true"
                className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
            >
                {latestProjects.map((project, index) => (
                    <ProjectCard
                        key={project.id}
                        project={project}
                        onOpenProject={() => { router.push(`/projets?project=${project.anchor}`); }}
                    />
                ))}
            </div>
            <ScrollRevealMount
                targetId="sr-home-proj-cards"
                mode="stagger"
                staggerEach={0.12}
                start="top 88%"
            />
        </section>
    );
}
